import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';

const PORT_DISPLAY_LENGTH = 3;

const formatters: Partial<Record<DeclarationCountry, (port: string) => string>> = {
    [DeclarationCountry.IRELAND]: (port) =>
        port.startsWith('IE') ? port.slice(2, 2 + PORT_DISPLAY_LENGTH) : 'Invalid Ireland Port',

    [DeclarationCountry.EU]: (port) => port.slice(0, PORT_DISPLAY_LENGTH),
};

export const getPortDisplayValue = (country: DeclarationCountry, port: string): string =>
    formatters[country]?.(port) ?? port;
